import React from 'react';
import { TextField } from '@mui/material';
import type { ExecuteCheckpointDef } from '@/types/run-stage.types';

interface CheckpointNumberProps {
  checkpoint: ExecuteCheckpointDef;
  value: unknown;
  onChange: (value: number | null) => void;
  error?: string;
  isReadOnly?: boolean;
}

export const CheckpointNumber: React.FC<CheckpointNumberProps> = ({
  checkpoint,
  value,
  onChange,
  error,
  isReadOnly,
}) => {
  return (
    <TextField
      size="small"
      fullWidth
      type="number"
      label={checkpoint.checkpointName}
      placeholder={`Enter ${checkpoint.checkpointName}`}
      value={value != null ? String(value) : ''}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v === '' ? null : Number(v));
      }}
      disabled={isReadOnly}
      error={Boolean(error)}
      helperText={error}
      required={checkpoint.required}
    />
  );
};
